
import abi from "./contract/GlobalPool.json";

import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Buy3 from "./component/buy3";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import jQuery from "jquery";


import "./logo.png";
import "./Global.gif";
import "./2.png";
import "./3.png";
import "./4.png";
import "./5.png";
import "./6.png";
import "./7.png";
import "./8.png";
import "./9.png";
import "./10.png";
import "./copy.png";


import { useState, useEffect } from "react";
import { ethers } from "ethers";

function App() {

  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  const [account, setAccount] = useState("None");
  
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[auto,setAuto]=useState("None");
  const[auto1,setAuto1]=useState("None");
  const[auto2,setAuto2]=useState("None");
  const[auto3,setAuto3]=useState("None");
  const[auto4,setAuto4]=useState("None");
  const[auto5,setAuto5]=useState("None");
  const[auto6,setAuto6]=useState("None");
  const [tasks1,setTasks1] = useState([]);
  const[auto7,setAuto7]=useState("None");
  const[bonus,setBonus]=useState("None");
  const[bonus1,setBonus1]=useState("None");
  const[pack,setpackage]=useState("None");
  const[refer,setrefer]=useState("None");
const [tasks,setTasks] = useState([]);

const [total,setTotal]=useState("None");
const [req,setreq]=useState("None");
const [tt,settt]=useState("None");
const[dd,setDD]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[bonanza1,setBonanza1]=useState("None");

const[wid,setwid]=useState("None");


  useEffect(() => {
    const connectWallet = async () => {
      const contractAddress = "0x4DDF0cC0a8599C8EbA5F975dCDC284d92C7D5351";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
      const myParam = searchParams.get('ref');
      console.log(myParam);
      
      
      document.querySelector("#name").value=myParam;
  if(myParam == null)
  {
    document.querySelector("#name").value="0xd61bc3e24B106d8dfaFCdA50703034187F70F370";
  }
      try {
        const { ethereum } = window;
        document.querySelector("#test").value = "Upgrade USDT 20";
        if (ethereum) {
          const account = await ethereum.request({
            method: "eth_requestAccounts",
           
          });
         
          window.ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          window.ethereum.on("accountsChanged", () => {
            
            window.location.reload();
          });

          const provider = new ethers.providers.Web3Provider(ethereum);
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
          let alltasks = await contract.getMemos(account[0]);
          setTasks(alltasks);
           let alltasks1 = await contract.getMemos1(account[0]);
          setTasks1(alltasks1);
          const auto7 = Number(alltasks1)-1;
setAuto7(auto7);
          const b =Number(alltasks[2]);
          const refer = (alltasks[1]);
         setrefer(refer);
         document.querySelector("#hid").value  = (alltasks[1]);
         const direct =Number(alltasks[2]);
         setDirect(direct);
         const directs =  Number(alltasks[22])/1000000000000000000;
         setDirects(directs);
         const level = Number(alltasks[23])/1000000000000000000;
         setLevel(level);
         const auto = Number(alltasks[11])/1000000000000000000;
         setAuto(auto);
         const auto1 = Number(alltasks[12])/1000000000000000000;
         setAuto1(auto1);
         const auto2 = Number(alltasks[13])/1000000000000000000;
         setAuto2(auto2);
         
         const auto3 = Number(alltasks[14])/1000000000000000000;
         setAuto3(auto3);
         
         const auto4 = Number(alltasks[15])/1000000000000000000;
         setAuto4(auto4);
         const auto5 = Number(alltasks[15])/1000000000000000000;
         setAuto5(auto5);
         const auto6 = Number(alltasks[16])/1000000000000000000;
         setAuto6(auto6);
        

         
         
         
         
         
         const bonus = Number(alltasks[18]);
         setBonus(bonus);
         const bonus1 = Number(alltasks[19]);
         setBonus1(bonus1);
         const total = Number(alltasks[10]);
         setTotal(total);

         const tt = directs + level + bonus + auto + total + auto1 + auto2 + auto3 + auto4 + auto5 + auto6  + bonus1;
         settt(tt);
         
         const pack = Number(alltasks[6]);
         document.querySelector("#pp").value  = Number(alltasks[6]);
         
    
    setpackage(pack);
    const bonanza = Number(alltasks[7]);
         setBonanza(bonanza);
         const bonanza1 = Number(alltasks[20]);
         setBonanza1(bonanza1);
          
         
    const dd = new Date(alltasks[8].timestamp * 1000).toLocaleString();
    setDD(dd);
         setB(b);
         const referlink = 'https://universalgain.online/?ref='+ account;
         setreflink(referlink);
         document.querySelector("#link").value =referlink;
    if(pack==20)
    { 
      document.querySelector("#test").value = "Upgrade USDT 30";
    
    }
    else if(pack==50)
    { 
      document.querySelector("#test").value = "Upgrade USDT 50";
    
    }
    else if(pack ==100)
    {
      document.querySelector("#test").value = "Upgrade USDT 100";
    }
    else if(pack ==200)
    {
      
      document.querySelector("#test").value = "Upgrade USDT 200";
    }
    else if(pack ==400)
    {
      document.querySelector("#test").value = "Upgrade USDT 400";
    }
    
    else if(pack ==800)
    {
      document.querySelector("#test").value = "Upgrade USDT 800";
    }
    else if(pack ==1600)
    {
      document.querySelector("#test").value = "Upgrade USDT 1600";
    }
    else if(pack ==3200)
    {
      document.querySelector("#test").value = "Upgrade USDT 3200";
    }
    else if(pack ==6400)
    {
      document.querySelector("#test").value = "Upgrade USDT 6400";
    }
    else if(pack == 12800)
    {

      document.querySelector("#test").value = "All Packages Purchased";
    }
    
    console.log(pack);
   
     
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
     
    
    
    connectWallet();
    
  }, []);

 
  // console.log(state);
        
       
  return (
   
<div >
<input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    {/* ─── SECTION 1: FEATURES (DARK BLUE) ─── */}
<section className="features-section" id="features">
  <div className="container">

    <div style={{ textAlign: "center", marginBottom: "10px" }}>
      <div className="section-tag">Our Core Pillars</div>
    </div>

    <h2
      className="section-title"
      style={{ textAlign: "center", margin: "0 auto 16px" }}
    >
      Technological <span className="hl">Innovation</span> & Empowerment
    </h2>

    <p
      className="section-desc "
      style={{ textAlign: "center", margin: "0 auto 0" }}
    >
      Making decentralized solutions accessible, secure, and meaningful
      for everyone on a global scale.
    </p>

    <div className="features-grid">

      <div className="feature-card">
        <div className="feat-icon">
          <i className="fas fa-shield-halved"></i>
        </div>

        <h3 className="feat-title">Total Joinings </h3>

        <p className="feat-desc">
            {auto7} 
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon orange">
          <i className="fas fa-users"></i>
        </div>

        <h3 className="feat-title">My Total Packages </h3>

        <p className="feat-desc">
          USDT {pack}  
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon gold">
          <i className="fas fa-globe"></i>
        </div>

        <h3 className="feat-title">My Direct Income </h3>

        <p className="feat-desc">
          USDT {directs}
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon">
          <i className="fas fa-link"></i>
        </div>

        <h3 className="feat-title">My Direct Team </h3>

        <p className="feat-desc">
         {direct}
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon orange">
          <i className="fas fa-seedling"></i>
        </div>

        <h3 className="feat-title">Total Income </h3>

        <p className="feat-desc">
         USDT {level}
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon gold">
          <i className="fas fa-landmark"></i>
        </div>

        <h3 className="feat-title">level - I Income </h3>

        <p className="feat-desc">
          USDT {auto}
        </p>
      </div>
       <div className="feature-card">
        <div className="feat-icon">
          <i className="fas fa-shield-halved"></i>
        </div>

        <h3 className="feat-title"> </h3>

        <p className="feat-desc">
          
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon orange">
          <i className="fas fa-users"></i>
        </div>

        <h3 className="feat-title"> level - II Income</h3>

        <p className="feat-desc">
         USDT {auto1}
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon gold">
          <i className="fas fa-globe"></i>
        </div>

        <h3 className="feat-title"> Level - III Income</h3>

        <p className="feat-desc">
          USDT {auto2}
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon">
          <i className="fas fa-link"></i>
        </div>

        <h3 className="feat-title">Level - IV Income </h3>

        <p className="feat-desc">
         USDT {auto3}
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon orange">
          <i className="fas fa-seedling"></i>
        </div>

        <h3 className="feat-title"> </h3>

        <p className="feat-desc">
         
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon gold">
          <i className="fas fa-landmark"></i>
        </div>

        <h3 className="feat-title"> Silver Royalty</h3>

        <p className="feat-desc">
          USDT {auto5}
        </p>
      </div>
       <div className="feature-card">
        <div className="feat-icon">
          <i className="fas fa-shield-halved"></i>
        </div>

        <h3 className="feat-title">Current Week Direct </h3>

        <p className="feat-desc">
          {bonus} 
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon orange">
          <i className="fas fa-users"></i>
        </div>

        <h3 className="feat-title">Single Leg Income </h3>

        <p className="feat-desc">
         USDT {auto6}
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon gold">
          <i className="fas fa-globe"></i>
        </div>

        <h3 className="feat-title"> </h3>

        <p className="feat-desc">
          
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon">
          <i className="fas fa-link"></i>
        </div>

        <h3 className="feat-title">Current Week Team </h3>

        <p className="feat-desc">
         {bonus1}
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon orange">
          <i className="fas fa-seedling"></i>
        </div>

        <h3 className="feat-title"><input type ="text" style={{color:"white" , backgroundColor:"rgba(0, 153, 204, 0.1)",textAlign:"center", border :"0",padding:"0.8rem" ,width:"50%"} }id ="test"></input> </h3>

        <p className="feat-desc">
          <Buy state={state} />
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon gold">
          <i className="fas fa-landmark"></i>
        </div>

        <h3 className="feat-title">Welcome To Universal Gain : </h3>

        <p className="feat-desc">
          Connected Account: {account}
        </p>
      </div>
       <div className="feature-card">
        <div className="feat-icon">
          <i className="fas fa-shield-halved"></i>
        </div>

        <h3 className="feat-title"> Refer Link</h3>

        <p className="feat-desc">
             {referlink}<button><img src ="copy.png" height={"25px"} onClick={() => {
  navigator.clipboard.writeText(referlink);}} /></button>
        </p>
      </div>

      <div className="feature-card ">
        <div className="feat-icon orange">
          <i className="fas fa-users"></i>
        </div>

        <h3 className="feat-title"> My Refer :</h3>

        <p className="feat-desc">
          {refer}
        </p>
      </div>

      
    </div>
  </div>
</section>
    
            

           
  
   

   

   
    


     

 


   
       
   

   

                          
    </div>                      
    

           
                   
	




     

  );
}

export default App;
